import script from "./DeliveryBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryBlock.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryBlock.vue?vue&type=style&index=0&id=75493c48&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75493c48"]])

export default __exports__